import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteABooking,
  getBookings,
  resetState,
  updateABooking,
  markBookingAsRead,
} from "../features/booking/bookingSlice";
import { AiFillDelete, AiOutlineEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Bookings = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [bookingId, setBookingId] = useState("");

  const showModal = (id) => {
    setOpen(true);
    setBookingId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(resetState());
    dispatch(getBookings());
  }, [dispatch]);

  const bookingState = useSelector((state) => state.booking.bookings);

  const handleReadBookingClick = (bookingId) => {
  
    dispatch(markBookingAsRead({ id: bookingId }));
  };

  const generateData = (bookings) =>
    bookings.map((booking, index) => ({
      key: index + 1,
      name: booking.name,
      email: booking.email,
      mobile: booking.mobile,
      status: (
        <select
          defaultValue={booking.status ? booking.status : "Submitted"}
          className="form-control form-select"
          onChange={(e) => setBookingStatus(e.target.value, booking._id)}
        >
          <option value="Submitted">Submitted</option>
          <option value="Contacted">Contacted</option>
        </select>
      ),
      action: (
        <>
          <Link
            className={`ms-3 fs-3 ${booking.read ? "text-secondary" : "text-primary"}`}
            to={`/admin/bookings/${booking._id}`}
            onClick={() => handleReadBookingClick(booking._id)}
          >
            <AiOutlineEye />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(booking._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
      className: booking.read ? "read-row" : "unviewed-row", // Apply class to differentiate by color
    }));

  const setBookingStatus = (status, id) => {
    dispatch(updateABooking({ id, bookingData: status }));
  };

  const deleteBooking = (id) => {
    dispatch(deleteABooking(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getBookings());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Bookings</h3>

      <Table
        columns={columns}
        dataSource={generateData(bookingState)} // Use all bookings in a single table
        rowClassName={(record) => record.className} // Apply row class based on read/unread
      />

      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteBooking(bookingId)}
        title="Are you sure you want to delete this booking?"
      />
    </div>
  );
};

export default Bookings;
